function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M58.6996 0.216445C58.437 -0.0113572 58.0632 -0.0642088 57.7464 0.0810895L0.510327 26.3799C0.202187 26.5215 0.00375671 26.8256 5.26747e-05 27.1615C-0.00365136 27.4975 0.188253 27.8057 0.493394 27.9538L16.6911 35.8149C16.9882 35.9591 17.3423 35.9265 17.6076 35.7304L33.3563 24.0902L20.9929 36.6664C20.8165 36.8459 20.7266 37.0917 20.746 37.3411L21.977 53.1947C22.0043 53.546 22.2424 53.8463 22.5809 53.9564C22.6714 53.9857 22.7643 54 22.8562 54C23.1083 54 23.3534 53.8931 23.524 53.6977L32.1212 43.8457L42.7492 48.8675C42.9799 48.9765 43.2469 48.981 43.4813 48.8802C43.7157 48.7792 43.8942 48.5828 43.9708 48.3417L58.9594 1.13341C59.0642 0.803743 58.9621 0.444248 58.6996 0.216445Z",
  fill: "#84CDBD"
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 13,
  y1: 47.4142,
  x2: 9.41421,
  y2: 51,
  stroke: "#84CDBD",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 26,
  y1: 56.4142,
  x2: 22.4142,
  y2: 60,
  stroke: "#84CDBD",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  x1: 16,
  y1: 55.4142,
  x2: 9.41421,
  y2: 62,
  stroke: "#84CDBD",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgRequestsent = function SvgRequestsent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 64,
    viewBox: "0 0 59 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRequestsent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/requestsent.90baf17c.svg";
export { ForwardRef as ReactComponent };